import { useState, useEffect, useCallback } from "react";
import { validate } from "@/utils/validators";
import { simulationSchema } from "../../simulation.schema";
import type { parsedApiError } from "@/types/api/errors.api";
import type { simulationFormData } from "@/features/userManagement/components/userFormModal/types.props";
import type { simulation } from "@/features/dashboard/types.api";

export const initialFormState: simulationFormData = {
    name: "",
    description: "",
    state: "in_design",
    type: "presencial",
};

export const useSimulationForm = (initialData?: simulation) => {
    const [formData, setFormData] =
        useState<simulationFormData>(initialFormState);
    const [formErrors, setFormErrors] = useState<parsedApiError | null>(null);
    const isEditMode = Boolean(initialData);

    useEffect(() => {
        if (initialData) {
            setFormData({
                name: initialData.name,
                description: initialData.description || "",
                state: initialData.state,
                type: initialData.type || "presencial",
            });
        } else {
            setFormData(initialFormState);
        }
    }, [initialData]);

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
            const { name, value } = e.target;
            setFormErrors(null);
            setFormData((prev) => ({ ...prev, [name]: value }));
        },
        [],
    );

    const validateForm = useCallback(() => {
        setFormErrors(null);
        const validationErrors = validate(formData, simulationSchema);
        if (Object.keys(validationErrors).length > 0) {
            const errorPayload: parsedApiError = {
                generalMessage: "Por favor, corrija los errores del formulario.",
                fieldErrors: validationErrors,
                code: "client_validation_error",
            };
            setFormErrors(errorPayload);
            return false;
        }
        return true;
    }, [formData]);

    return {
        formData,
        formErrors,
        setFormErrors,
        isEditMode,
        handleInputChange,
        validateForm,
    };
};
